import posthog from 'posthog-js';

import { isPostHogCaptureEnabled } from '@eudia/utils/envs/is-posthog-capture-enabled';

import { getSharedPostHogOptions } from './libs/posthog-init-options';

/**
 * Initialise PostHog as early as possible — call from instrumentation-client.ts
 * so the SDK is ready before React renders and before LCP/FCP are observed.
 *
 * posthog-js handles a second posthog.init() call (from AnalyticsProvider's
 * useEffect) gracefully: it no-ops when the same project token is already
 * loaded.  AnalyticsProvider continues to own identify(), register(), and
 * feature-flag management as before.
 *
 * Non-production environments initialise PostHog for feature flags only; event
 * capture remains enabled in production.
 */
export function initPostHog(apiKey: string): void {
  if (typeof window === 'undefined' || !apiKey) return;

  const captureEnabled = isPostHogCaptureEnabled;

  posthog.init(apiKey, {
    ...getSharedPostHogOptions({ captureEnabled }),
    api_host: '/ph',
    defaults: '2026-01-30',
    capture_pageview: false,
    capture_pageleave: captureEnabled,
    autocapture: captureEnabled,
    capture_performance: captureEnabled,
    person_profiles: 'identified_only',
    cross_subdomain_cookie: false,
    advanced_disable_feature_flags_on_first_load: true,
    mask_all_text: true,
    mask_all_element_attributes: true,
  });
}
